import { Backend, Frontend } from "shared-types";
import axios from "../utils/axios";
import url from "../utils/urls";

export const analyzeFile = async (file: File | Blob, onUploadProgress: (progressEvent: ProgressEvent) => void = () => { }) => {
    const formData = new FormData();
    formData.append("file", file);
    const response: Frontend.T_Response<{ result: Backend.T_AnalyzeAndSave }> = await axios.post(url.upload.analyze, formData, {
        onUploadProgress
    });
    return response.data.data.result;
}

export const getUploadInfo = async (id: number) => {
    const response: Frontend.T_Response<{ info: Backend.T_Upload }> = await axios.get(url.upload.get(id));
    return response.data.data.info;
}

export const getUploadFile = async (id: number): Promise<Blob> => {
    const response = await axios.get(url.upload.getFile(id));
    return response.data;
}